export var DefaultDateRange;
(function (DefaultDateRange) {
    DefaultDateRange["YESTERDAY"] = "yesterday";
    DefaultDateRange["LAST_SEVEN_DAYS"] = "last_seven_days";
    DefaultDateRange["LAST_THIRTY_DAYS"] = "last_thirty_days";
    DefaultDateRange["THIS_MONTH"] = "this_month";
    DefaultDateRange["LAST_MONTH"] = "last_month";
})(DefaultDateRange || (DefaultDateRange = {}));
export var OpenApiPeriod;
(function (OpenApiPeriod) {
    OpenApiPeriod["Daily"] = "daily";
})(OpenApiPeriod || (OpenApiPeriod = {}));
//# sourceMappingURL=period.js.map